/* Vellaskim · ofertas del carrito lateral: cambio de pack (Kaching), regalo 2+2, envío seguro. Rápido: 1 llamada por acción. */
(function () {
  if (window.__vkCartOffers) return;
  window.__vkCartOffers = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CREMA_VARIANT = 58736612049280;
  var CREMA_PP = 15908060430720;
  var KDEAL = 'ZuCS';
  var KV = '16d471b4-de3b-47a9-a532-1ae53b3de368';
  var BID = { 1: 'IYTz', 2: 'NwwI', 4: 'RzU3' }; // barras Kaching: 1 tubo, 1+1, 2+2
  var busy = false;

  // XHR: no dispara el "abrir carrito" de vk-cart.js
  function req(method, url, data) {
    return new Promise(function (res, rej) {
      var x = new XMLHttpRequest();
      x.open(method, ROOT + url);
      x.setRequestHeader('Accept', 'application/json');
      if (data) x.setRequestHeader('Content-Type', 'application/json');
      x.onload = function () { var j = {}; try { j = JSON.parse(x.responseText); } catch (e) {} j.__status = x.status; res(j); };
      x.onerror = rej;
      x.send(data ? JSON.stringify(data) : null);
    });
  }
  function drawer() { return document.getElementById('vk-drawer'); }
  function body() { var d = drawer(); return d && d.querySelector('[data-vk-body]'); }
  function sid() {
    var d = drawer(); if (!d) return null;
    var w = d.closest('[id^="shopify-section-"]');
    return w ? w.id.replace('shopify-section-', '') : null;
  }
  function state() {
    var st = document.getElementById('vk-cart-state');
    if (!st) return null;
    var list = function (v) { return (v || '').split(',').filter(Boolean); };
    var props = {};
    try { props = JSON.parse(st.getAttribute('data-crema-props') || '{}') || {}; } catch (e) {}
    return {
      crema: +st.dataset.crema || 0,
      gift: +st.dataset.gift || 0,
      cremaKeys: list(st.dataset.cremaKeys),
      giftKeys: list(st.dataset.giftKeys),
      legacyKeys: list(st.dataset.legacyKeys),
      props: props
    };
  }

  // Pinta el carrito nuevo y anima la barra desde donde estaba
  function swap(html) {
    var t = document.createElement('div');
    t.innerHTML = html || '';
    var nb = t.querySelector('[data-vk-body]');
    var ob = body();
    if (!nb || !ob) return false;
    var of = ob.querySelector('.vkc-fill');
    var oldW = of ? of.style.width : null;
    var os = ob.querySelector('.vkc-scroll');
    var top = os ? os.scrollTop : 0;
    ob.replaceWith(nb);
    var nf = nb.querySelector('.vkc-fill');
    if (nf && oldW && oldW !== nf.style.width) {
      var target = nf.style.width;
      nf.style.transition = 'none';
      nf.style.width = oldW;
      void nf.offsetWidth;
      nf.style.transition = '';
      requestAnimationFrame(function () { nf.style.width = target; });
    }
    var ns = nb.querySelector('.vkc-scroll');
    if (ns) ns.scrollTop = top;
    var c = parseInt(nb.getAttribute('data-count') || '0', 10);
    document.querySelectorAll('[data-vk-count]').forEach(function (e) { e.textContent = c; e.hidden = c < 1; });
    return true;
  }
  function refresh() {
    var id = sid(); if (!id) return Promise.resolve();
    return req('GET', '?sections=' + encodeURIComponent(id)).then(function (j) { swap(j[id]); });
  }
  // Llamada al carrito que devuelve ya el carrito pintado (sin segunda petición)
  function act(url, data) {
    var id = sid();
    if (id) { data.sections = id; data.sections_url = location.pathname; }
    return req('POST', url, data).then(function (j) {
      if (j.__status >= 400 && j.description && /add/.test(url)) alert(j.description);
      if (!(id && j.sections && swap(j.sections[id]))) return refresh();
    });
  }

  function rid() {
    var c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', s = '';
    for (var i = 0; i < 4; i++) s += c[Math.floor(Math.random() * c.length)];
    return s;
  }
  function kachingProps(src, qty) {
    var props = {}, k = null;
    Object.keys(src || {}).forEach(function (key) {
      if (key.indexOf('_sternify') === 0) return;
      props[key] = src[key];
    });
    try { k = JSON.parse(props.__kaching_bundles || 'null'); } catch (e) { k = null; }
    if (!k) k = { deal: KDEAL, pp: CREMA_PP, main: true, v: KV };
    k.bid = BID[qty] || BID[4];
    if (qty === 1) delete k.id; else if (!k.id) k.id = rid();
    props.__kaching_bundles = JSON.stringify(k);
    return props;
  }

  // Cambio de pack en UNA sola llamada (Kaching parte el pack en varias líneas; dos llamadas seguidas daban error)
  function setPack(target) {
    var s = state() || { cremaKeys: [], props: {}, crema: 0 };
    if (target && s.crema === target) return Promise.resolve();
    var keys = s.cremaKeys.filter(function (k, i, a) { return a.indexOf(k) === i; });
    if (!keys.length) {
      if (!target) return Promise.resolve();
      return act('cart/add.js', { items: [{ id: CREMA_VARIANT, quantity: target, properties: kachingProps(null, target) }] });
    }
    if (keys.length === 1) {
      var line = parseInt((document.getElementById('vk-cart-state') || {}).dataset.cremaLine, 10) || 0;
      var d = { quantity: target };
      if (line > 0) d.line = line; else d.id = keys[0];
      if (target) d.properties = kachingProps(s.props, target);
      return act('cart/change.js', d);
    }
    var up = {};
    keys.forEach(function (k, i) { up[k] = i === 0 ? target : 0; });
    return act('cart/update.js', { updates: up });
  }

  // Regalo: cápsulas a $0 cuando el carrito (sin el regalo) llega al mínimo; se quitan si baja. Restos antiguos fuera.
  function fix() {
    var st = document.getElementById('vk-cart-state');
    var s = state(); if (!s || !st) return null;
    var ok = st.dataset.giftOk === 'true';
    var gv = parseInt(st.dataset.giftVariant, 10) || 0;
    var up = {}, n = 0;
    s.legacyKeys.forEach(function (k) { up[k] = 0; n++; });
    if (!ok) s.giftKeys.forEach(function (k) { up[k] = 0; n++; });
    else if (s.gift > 1 && s.giftKeys.length) { s.giftKeys.forEach(function (k, i) { up[k] = i === 0 ? 1 : 0; }); n++; }
    if (n) return function () { return act('cart/update.js', { updates: up }); };
    if (ok && gv && !s.giftKeys.length) {
      return function () { return act('cart/add.js', { items: [{ id: gv, quantity: 1, properties: { _vk_regalo: 'Regalo $1,200' } }] }); };
    }
    return null;
  }

  function run(job) {
    if (busy) return;
    busy = true;
    var b = document.querySelector('#vk-drawer .vkc');
    if (b) b.classList.add('vkc-busy');
    var guard = 0;
    function after() {
      var f = fix();
      if (f && guard++ < 2) return f().then(after);
    }
    Promise.resolve()
      .then(job)
      .then(after)
      .catch(function (e) { console.error('[vk-cart-offers]', e); return refresh(); })
      .then(function () {
        busy = false;
        var nb = document.querySelector('#vk-drawer .vkc');
        if (nb) nb.classList.remove('vkc-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var b = t.closest('#vk-drawer [data-vk]');
    if (!b) return;
    e.preventDefault();
    if (busy) return;
    var a = b.getAttribute('data-vk');
    if (a === 'pack') {
      var tg = parseInt(b.getAttribute('data-target'), 10) || 0;
      run(function () { return setPack(tg); });
    } else if (a === 'qty') {
      var q = Math.max(0, parseInt(b.getAttribute('data-q'), 10) || 0);
      var key = b.getAttribute('data-key');
      run(function () { return act('cart/change.js', { id: key, quantity: q }); });
    } else if (a === 'add') {
      var v = parseInt(b.getAttribute('data-variant'), 10);
      run(function () { return act('cart/add.js', { items: [{ id: v, quantity: 1 }] }); });
    } else if (a === 'seguro') {
      var on = b.getAttribute('aria-pressed') === 'true';
      var sk = b.getAttribute('data-key');
      var sv = parseInt(b.getAttribute('data-variant'), 10);
      b.setAttribute('aria-pressed', on ? 'false' : 'true'); // respuesta visual inmediata
      run(function () {
        return on && sk ? act('cart/change.js', { id: sk, quantity: 0 }) : act('cart/add.js', { items: [{ id: sv, quantity: 1 }] });
      });
    }
  });

  // Si el carrito cambia desde fuera (página de producto, Kaching), corrige el regalo
  var tm, fixes = [];
  function check() {
    clearTimeout(tm);
    tm = setTimeout(function () {
      if (busy || !fix()) return;
      var now = Date.now();
      fixes = fixes.filter(function (x) { return now - x < 15000; });
      if (fixes.length >= 2) return;
      fixes.push(now);
      run(function () {});
    }, 150);
  }
  function boot() {
    var d = drawer();
    if (d) new MutationObserver(check).observe(d, { childList: true, subtree: true });
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
